import React, { useState } from "react";
import { NavLink } from "react-router-dom"; // Import NavLink for navigation
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import logo from "../assets/images/logo.jpg";

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
          <nav className="bg-gray-900 fixed top-0 w-full z-50 shadow-lg">
        {/* Top Layer */}
        <div className="bg-gray-800 text-sm py-2 px-6 flex justify-between items-center animate-fadeIn">
          <span className="font-sans text-yellow-300">📞 +254 707 800 945</span>
          <div className="relative group">
            {/* Portals Button */}
            <button
              className="bg-gray-700 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded inline-flex items-center"
              aria-haspopup="true"
            >
              <span>Portals</span>
              <svg
                className="fill-current w-4 h-4 ml-2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
              </svg>
            </button>
            {/* Dropdown Menu */}
            <div
              className="hidden group-hover:block absolute bg-gray-700 text-white mt-2 w-48 rounded-lg shadow-lg"
            >
              <a
                href="https://joygardens.smartshule.com/login"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-4 py-2 hover:bg-gray-600 hover:text-yellow-300 transition font-sans font-bold"
              >
                Teachers Portal
              </a>
              <a
                href="https://joygardens.smartshule.com/login"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-4 py-2 hover:bg-gray-600 hover:text-yellow-300 transition font-sans font-bold"
              >
                Parents Portal
              </a>
              <a
                href="https://joygardens.smartshule.com/login"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-4 py-2 hover:bg-gray-600 hover:text-yellow-300 transition font-sans font-bold"
              >
                Students Portal
              </a>
            </div>
          </div>
        </div>



      {/* Main Navigation Layer */}
      <div className="w-full flex justify-between items-center px-6 py-4 bg-white">
  {/* Logo */}
  <div className="flex items-center space-x-4">
    <Link to="/"> {/* Wrap the logo with Link */}
      <img
        src={logo}
        alt="Joy Gardens School Logo"
        className="h-12 w-12 rounded-lg border border-gray-300 transform transition-transform duration-500 hover:rotate-180 hover:scale-110 cursor-pointer"
      />
    </Link>
          <div className="flex space-x-1">
            <span className="text-2xl font-bold tracking-wide text-red-500 font-serif">J</span>
            <span className="text-2xl font-bold tracking-wide text-orange-500 font-serif">o</span>
            <span className="text-2xl font-bold tracking-wide text-yellow-500 font-serif">y</span>
            <span className="text-2xl font-bold tracking-wide text-green-500 font-serif">G</span>
            <span className="text-2xl font-bold tracking-wide text-blue-500 font-serif">a</span>
            <span className="text-2xl font-bold tracking-wide text-purple-500 font-serif">r</span>
            <span className="text-2xl font-bold tracking-wide text-pink-500 font-serif">d</span>
            <span className="text-2xl font-bold tracking-wide text-red-500 font-serif">e</span>
            <span className="text-2xl font-bold tracking-wide text-orange-500 font-serif">n</span>
            <span className="text-2xl font-bold tracking-wide text-yellow-500 font-serif">s</span>
          </div>
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-8 items-center font-sans text-gray-700">
          <li>
            <NavLink
              to="/"
              className="hover:text-blue-500 text-gray-900 transition cursor-pointer font-medium"
              exact
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              className="hover:text-blue-500 text-gray-900 transition cursor-pointer font-medium"
            >
              About
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admissions"
              className="hover:text-blue-500 text-gray-900 transition cursor-pointer font-medium"
            >
              Admissions
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className="hover:text-blue-500 text-gray-900 transition cursor-pointer font-medium"
            >
              Contact
            </NavLink>
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <XIcon className="h-6 w-6 text-gray-900" />
            ) : (
              <MenuIcon className="h-6 w-6 text-gray-900" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <ul className="md:hidden bg-gray-800 text-white p-4 space-y-4 font-sans">
          <li>
            <NavLink
              to="/"
              className="hover:text-blue-500 text-yellow-500 transition cursor-pointer font-medium"
              exact
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              className="hover:text-blue-500 text-yellow-500 transition cursor-pointer font-medium"
            >
              About
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admissions"
              className="hover:text-blue-500 text-yellow-500 transition cursor-pointer font-medium"
            >
              Admissions
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className="hover:text-blue-500 text-yellow-500 transition cursor-pointer font-medium"
            >
              Contact
            </NavLink>
          </li>
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
